import {isnull} from "./tools";
import TopRtcDelegate from "../rtc/TopRtcDelegate";
import AgoraRTC from "agora-rtc-sdk-ng";

export default class HWLPLayer {
  static srcMap = new Map()

  static currentHWL = null


  static addAudiAddr(src, loop = false, muted = false, autoPlay = false, listener = null, listenerParams = []) {
    if (isnull(src))
      return
    if (!this.srcMap.has(src)) {
      // AgoraRTC.createBufferSourceAudioTrack({
      //   cacheOnlineFile: true,
      //   source: src
      // }).then(localTrack => {
      //   localTrack.on('source-state-change', curState => {
      //     switch (curState) {
      //       case 'stopped':
      //         listener && listener.onStop && listener.onStop(listenerParams)
      //         break
      //       case 'paused':
      //         listener && listener.onPause && listener.onPause(listenerParams)
      //         break
      //       case 'playing':
      //         listener && listener.onPlay && listener.onPlay(listenerParams)
      //         break
      //     }
      //   })
      //   this.srcMap.set(src, localTrack)
      // })
      let sound = new Howl({
        src: [src],
        autoPlay: autoPlay,
        usingWebAudio: true,
        loop: loop,
        muted: muted,
        preload: true,
      })
      this.srcMap.set(src, sound)
    }
    let originSound = this.srcMap.get(src);
    originSound.on('play', () => {
      listener && listener.onPlay && listener.onPlay(listenerParams)
    })
    originSound.on('pause', () => {
      listener && listener.onPause && listener.onPause(listenerParams)
    })
    originSound.on('stop', () => {
      listener && listener.onStop && listener.onStop(listenerParams)
    })
    originSound.on('end', () => {
      listener && listener.onEnd && listener.onEnd(listenerParams)
    })
    originSound.on('loaderror', (id, msg) => {
      listener && listener.onLoaderror && listener.onLoaderror(listenerParams)
    })


  }

  static clearAll() {
    this.srcMap.clear()
  }

  static removeAudio(src) {
    this.srcMap.delete(src)
  }

  static playAudio(src) {
    if (!this.srcMap.has(src))
      return
    let targetHWL = this.srcMap.get(src);
    if (targetHWL != this.currentHWL) {
      if (this.currentHWL && this.currentHWL.playing())
        this.currentHWL.stop()
      // if (this.currentHWL && this.currentHWL.isPlaying)
      //   this.currentHWL.stop()

      this.currentHWL = targetHWL
      this.currentHWL.play()
    } else {
      if (this.currentHWL && !this.currentHWL.playing())
        this.currentHWL.play()
      // if (this.currentHWL && !this.currentHWL.isPlaying)
      //   this.currentHWL.play()
    }
  }

  static pauseAudio(src) {
    if (!this.srcMap.has(src))
      return
    let targetHWL = this.srcMap.get(src);
    if (targetHWL != this.currentHWL) {
      return;
    }
    if (this.currentHWL.playing())
      this.currentHWL.pause()
    // if (this.currentHWL.isPlaying)
    //   this.currentHWL.pause()


  }

  static stopAll() {
    if (this.currentHWL && this.currentHWL.playing())
      this.currentHWL.stop()
    // if (this.currentHWL && this.currentHWL.isPlaying)
    //   this.currentHWL.stop()
  }

  static stopAudio(src) {
    if (!this.srcMap.has(src))
      return
    let targetHWL = this.srcMap.get(src);
    if (targetHWL != this.currentHWL) {
      return;
    }
    if (this.currentHWL.playing())
      this.currentHWL.stop()
    // if (this.currentHWL.isPlaying)
    //   this.currentHWL.stop()
  }
}



// WEBPACK FOOTER //
// ./src/utils/hwlplayer.js